import React, { useEffect, useState } from "react";
import { TbChevronLeft, TbChevronRight } from "react-icons/tb";
import './stylesPagination.scss'

interface PaginationProps {
    totalItems?: number;
    itemsCountPerPage?: number;
    className?: string;
    changePage: any;
    changeCurrentPage?: any;
    pagination: any
}

const Pagination = (props: PaginationProps) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(0);
    const [pages, setPages] = useState<Number[]>([]);

    useEffect(() => {
        setCurrentPage(props.changeCurrentPage)
    }, [props.changeCurrentPage])

    useEffect(() => {
        var totalItems: number = props.totalItems ? props.totalItems : Number(10);
        var itemsCountPerPage: number = props.itemsCountPerPage
            ? props.itemsCountPerPage
            : Number(10);
        const totalPage = Math.ceil(totalItems / itemsCountPerPage);
        setLastPage(totalPage);
        var temp = [];
        let startPage, endPage;
        if (totalPage <= 5) {
            startPage = 1;
            endPage = totalPage;
        } else {
            if (currentPage <= 3) {
                startPage = 1;
                endPage = 5;
            } else if (currentPage + 2 >= totalPage) {
                startPage = totalPage - 4;
                endPage = totalPage;
            } else {
                startPage = currentPage - 2;
                endPage = currentPage + 2;
            }
        }
        for (let i = startPage; i <= endPage; i++) {
            temp.push(i);
        }
        setPages(temp);
    }, [currentPage, props.totalItems]);

    const changepage = (page: number) => {
        setCurrentPage(page);
        props.changePage(page);
    };

    const nextchangepage = () => {
        setCurrentPage(currentPage == lastPage ? lastPage : currentPage + 1);
        props.changePage(currentPage == lastPage ? lastPage : currentPage + 1);
    };
    const previouschangepage = () => {
        setCurrentPage(currentPage == 1 ? currentPage : currentPage - 1);
        props.changePage(currentPage == 1 ? currentPage : currentPage - 1);
    };

    return (
        <>
            <div className='pagination'>
                <div className="arrow-box paginatin-btn pagination-item" onClick={() => previouschangepage()}>
                    <TbChevronLeft size={18} />
                </div>

                {pages.map((page: any, index: number) => {
                    return (
                        <div key={"pagable_" + index} className="count-box cursor-pointer">
                            <div
                                className={
                                    page === currentPage
                                        ? "pagination-item active"
                                        : "pagination-item"
                                }
                                onClick={() => changepage(page)}
                            >
                                {page}
                            </div>
                        </div>
                    );
                })}
                <div className="arrow-box paginatin-btn pagination-item" onClick={() => nextchangepage()}>
                    <TbChevronRight size={18} />
                </div>
            </div>
        </>
    );
};

export default Pagination;
